/**
 * Created by wjjn3481 on 2017/7/24.
 */

export default {
    methods: {
        highEducationDesc(highEducation) {
            return `${highEducation.school} - ${highEducation.major}`
        },
        followerText(user) {
            return (user && user.name) || '-'
        },
        sourceFromSearchProcess(res, fileName = 'resumeResumeSourceSearch') {
            let targetIndex = 0
            res.result.WB_SOURCE_FROM = this.selectMap.WB_SOURCE_FROM
            this.filterConf.forEach((item, index) => {
                if (item.name === 'sourceFromSearch') {
                    targetIndex = index
                }
            })
            if (this.searchData[fileName] && this.searchData[fileName].length) {
                if (this.searchData[fileName].split(',').indexOf('22') > -1) {
                    this.filterConf[targetIndex].visible = true
                    this.filterConf[targetIndex].value = this.searchData.sourceFromSearch
                    this.filterConf[targetIndex].data = this.selectMap.WB_SOURCE_FROM
                    return true
                }
            }
            this.filterConf[targetIndex].visible = false
            this.filterConf[targetIndex].value = ''
            this.searchData.sourceFromSearch = ''
            this.$router.push({ query: Object.assign({}, this.searchData) })
        },
        multiChangePosition(ids) {
            if (this.checkDataValid(ids)) {
                let $target = this.$refs.changePositionDialog
                $target && $target.show(ids, this.multipleSelection)
            }
        },
        syncToSupplier(ids) {
            if (this.checkDataValid(ids)) {
                this.$confirm('将进行批量同步供应商，是否继续？', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                })
                    .then(() => {
                        this.$axios
                            .post(
                                '/evaluation/syncEva.api',
                                {
                                    resumePositionIds: ids
                                },
                                { 'X-showMessage': true }
                            )
                            .then(res => {})
                    })
                    .catch(console.error)
            }
        }
    }
}



// WEBPACK FOOTER //
// ./src/views/operation/queryListMixin.js